module.exports = __webpack_public_path__ + "static/media/person9.55332f3f.svg";